import type { PopupData } from 'webapp-types';

import PopupInnerContextComponent from 'webapp/components/popup/inner/context';
import TagPickerComponent from 'webapp/components/tag-picker';

export default class TagPopupTagsContextComponent extends PopupInnerContextComponent<PopupData.Tag.Context> {
	<template>
		<TagPickerComponent
			@model={{this.popupData.model}}
			@theme={{@model.theme}}
			@onContentChanged={{this.reposition}}
			@onClose={{this.close}}
			@onApplySelected={{this.popupData.onApplySelected}}
		/>
	</template>
}
